import React from "react";
import { useSelector } from "react-redux";
import styles from "../MainHeader.module.scss";
import { SettingsIcon } from "@netapp/bxp-style/react-icons/Action";
import { HeaderSettingsIcon } from "@netapp/bxp-design-system-react/icons/monochrome";
import SlidingWidget from "./SlidingWidget";
import _ from "lodash";
import { isNewTenancyEnabled } from "utils/localstorage";
import { useTranslation } from "react-i18next";
import { allMenus as i18nNamespace } from "../../../../i18n/namespace";
import usePermission from "utils/usePermission";
import PermissionMenuLink from "./PermissionMenuLink";

const Content = React.memo(() => {
    const activeAgent = useSelector(state => state.tenancy.selectedAgent);
    const noConnector = process.env.REACT_APP_IS_SAAS === "true" && !activeAgent;
    const darkSite = process.env.REACT_APP_IS_DARK === 'true';
    const installLocation = useSelector(state => state.app.instancePlacement?.installLocation?.toLowerCase());
    // Get the Feature flag state from Redux state.
    const isTenancyV4 = isNewTenancyEnabled();
    const { t } = useTranslation(i18nNamespace);
    const { permissions } = useSelector(state => state.tenancy);
    const permissionsKeysForSettingsMenu = ["cvo_settings", "timeline", "credentials", "https_setup", "notifications"];
    const hasPermission = usePermission(permissionsKeysForSettingsMenu);
    if (process.env.REACT_APP_IS_AIDP === "true") {
        return <div className={styles['menu-content']}>
            <PermissionMenuLink hasPermission={hasPermission({ permissionKey: "notifications" }) && !darkSite} title={t("alerts_and_notifications_settings")} to="/alerts-and-notifications/users"/>
        </div>;
    }

    return <div className={styles["menu-content"]}>
            {/* If Tenancy V4 enabled from feature flag, then show this Menu Item in settings page. */}
            { isTenancyV4 && <PermissionMenuLink
                hasPermission={ permissions.editAccount}
                title={t("identity_and_access_management")}
                to="/identity-access-mgmt/organization"
            />}
            <PermissionMenuLink
                hasPermission={hasPermission({
                    permissionKey: "cvo_settings",
                })}
                title={t("cloud_volumes_ontap_settings")}
                to="/connector-settings/settings"
                disabled={noConnector}
            />
            <PermissionMenuLink
                hasPermission={hasPermission({
                    permissionKey: "timeline",
                })}
                title={t("timeline")}
                to="/timeline"
            />
            <PermissionMenuLink
                hasPermission={hasPermission({
                    permissionKey: "credentials",
                })}
                title={t("credentials")}
                to="/credentials/account-credentials"
                disabled={darkSite && installLocation === "onprem"}
            />
            <PermissionMenuLink
                hasPermission={hasPermission({
                    permissionKey: "https_setup",
                })}
                title={t("https_setup")}
                to="/connector-settings/certificate-setup"
                disabled={noConnector}
            />
            <PermissionMenuLink
                hasPermission={hasPermission({ permissionKey: "notifications" }) && !darkSite}
                title={t("alerts_and_notifications_settings")}
                to="/alerts-and-notifications/users"
            />
        </div>;

});

export default () => {
    const { forbidden, permissions } = useSelector(state => state.tenancy);
    const disabled = (process.env.REACT_APP_IS_SAAS !== "true" && forbidden) || (!permissions.allTabsAvailable && !permissions.editAccount);
    const { t } = useTranslation(i18nNamespace);

    return <SlidingWidget
        widgetKey="settings"
        menuTitle={t("settings")}
        MenuIcon={SettingsIcon}
        triggerClassName={styles['widget-button']}
        triggerActiveClassName={[styles['widget-button-active']]}
        triggerChildren={<HeaderSettingsIcon size={24} display="block"/>}
        triggerDisabled={disabled}
    >
        <Content/>
    </SlidingWidget>;
};
